export const NO_PLAYER_FOUND = 30000; // in ms

export const TIME_BEFORE_SHOW_TIMER_IN_MODALS = 120000; // in ms

export const SHOW_REVEAL_BTN = 120000; // in ms

export const TIME_FOR_TRANSACTION_MINTING = 210000; // in ms
